import React, {Component} from 'react';
import {Field, FieldArray, reduxForm, formValueSelector} from 'redux-form'
import {connect} from 'react-redux';
import Toggle from 'react-toggle';

import conf from '../../../conf.js';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler';
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Select from '../../Form/Field/Select.jsx';
import CheckboxContainer from '../../Form/Field/CheckboxContainer.jsx';
import CitiesTypeahead from '../../Form/Field/CitiesTypeahead.jsx';
import validate from './validate.js';
import Date from '../../Form/Field/Date.jsx';

export const name = 'AlertOffersForm';

class AlertOffersForm extends Component {
  render() {
    const channels = this.props?.channel?.length ? this.props.channel : [];
    const {emailSelected, smsSelected} = channels.reduce((acc, channel) => {
      if (channel.value === true && channel.text === conf.alert.channels.email.text) {
        acc.emailSelected = true;
      }

      if (channel.value === true && channel.text === conf.alert.channels.sms.text) {
        acc.smsSelected = true;
      }

      return acc;
    }, {emailSelected: false, smsSelected: false});

    return (
      <div id={name}>
        <h2 className="text-center">Gestion de vos alertes</h2>
        <p className="text-center mb-5">Ne ratez aucune des nouvelles missions disponibles !</p>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className="text-center mt-5 mb-4">
            <h4>Préférences générales</h4>
          </div>
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <p className="text-center">Sélectionnez comment vous souhaitez être notifié des nouvelles annonces</p>
              <FieldArray
                name="channel"
                component={CheckboxContainer}
              />
              <p className="text-center">
                <em>Les notifications par SMS vous seront envoyées à chaque nouvelle annonce.</em>
              </p>
            </div>
          </div>
          {emailSelected &&
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <Field
                label="Fréquence de notification par mail"
                name="frequency"
                type="select"
                component={Select}>
                {Object.keys(conf.alert.frequency).map((key) => {
                  const value = conf.alert.frequency[key].value;
                  return <option value={value} key={value}>{conf.alert.frequency[key].text}</option>
                })}
              </Field>
            </div>
          </div>
          }
          {(emailSelected || smsSelected) &&
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <Field
                name="suspended_until"
                label="Je souhaite recevoir les notifications uniquement après le :"
                placeholder="JJ//MM/AAAA"
                type="text"
                component={Date}/>
            </div>
          </div>
          }
          <div className="text-center mt-5 mb-4">
            <h4>Préférences géographiques</h4>
          </div>
          <div className="col-sm-12 mt-2 mb-5 text-center toggle-consultant-company">
            <label className="d-flex justify-content-center align-items-center">
              <span className={`${(this.props.citiesSelected ? '' : 'focus')} label-text mx-2`}>Toute la France</span>
              <Toggle icons={false} checked={this.props.citiesSelected} onChange={this.props.handleCitiesSelectedChange}/>
              <span
                className={`${(!this.props.citiesSelected ? '' : 'focus')} label-text mx-2`}>Une sélection de villes</span>
            </label>
          </div>
          {this.props.citiesSelected &&
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <Field
                placeholder="Paris, Bordeaux..."
                name="cities"
                label="Dans un périmètre de 100 km autour de"
                component={CitiesTypeahead}
              />
            </div>
          </div>
          }
          <div className="text-center mt-5 mb-4">
            <h4>Préférences métiers</h4>
          </div>
          <p className="text-center">Sélectionnez les sous-catégories qui vous intéressent</p>
          <FieldArray
            id="subUniverses"
            name="subUniverses"
            component={CheckboxContainer}
          />
          <input type="submit" className="d-none"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
      </div>
    );
  }
}

const ReduxAlertOffersForm = reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(AlertOffersForm);

const selector = formValueSelector(name);

export default connect(
  state => ({
    channel: selector(state, 'channel')
  })
)(ReduxAlertOffersForm);